import React, {useEffect, useState} from 'react';
import { ThemeContext } from '@/components/theme/theme-context';
import type { Theme, ActualTheme } from '@/components/theme/theme-context';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [theme, setTheme] = useState<Theme>('dark');
    const [actualTheme, setActualTheme] = useState<ActualTheme>('dark');

    const applyTheme = (newTheme: ActualTheme) => {
        const root = window.document.documentElement;
        root.classList.remove('light', 'dark');
        root.classList.add(newTheme);
        setActualTheme(newTheme);
    };

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleChange = () => {
            if (theme === 'system') {
                applyTheme(mediaQuery.matches ? 'dark' : 'light');
            }
        };

        handleChange(); // Initial check
        mediaQuery.addEventListener('change', handleChange);

        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [theme]);

    useEffect(() => {
        if (theme === 'system') {
            const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            applyTheme(systemTheme);
        } else {
            applyTheme(theme as ActualTheme);
        }
    }, [theme]);

    return (
        <ThemeContext.Provider value={{theme, actualTheme, setTheme}}>
            {children}
        </ThemeContext.Provider>
    );
};